<template>
  <WebTop />
  <div id="body-wrap">

  <div class="home-block-title" style="margin-top: 24px;">
    <Icon type="ios-book-outline" color="#2d8cf0" /> <b style="color: #2d8cf0">提问</b>
  </div>

  

  <!---发帖--->
  <div id="thread-add-wrap">
    <div style="height: 30px; line-height: 30px; font-size: 18px;">投诉举报</div>
    <div style="border: 1px solid #ccc; padding: 24px; padding-bottom: 0;">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="56">
        <FormItem label="姓名" prop="realName">
          <Input v-model="formValidate.realName" type="text" placeholder="提问标题"></Input>
        </FormItem>  
        <FormItem label="手机" prop="mobile">
          <Input v-model="formValidate.mobile" type="text" placeholder="提问标题"></Input>
        </FormItem>  
        <FormItem label="标题" prop="title">
          <Input v-model="formValidate.title" type="text" placeholder="提问标题"></Input>
        </FormItem>  
        <FormItem label="内容" prop="content">
          <Input v-model="formValidate.content" type="textarea" :rows="6" placeholder="内容"></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formValidate')">提问</Button>
        </FormItem>
      </Form>
    </div>
  </div>

</div>

</template>
<script>
import WebTop from '../../components/WebTop.vue'
import global from '../../utils/global'
import axios from 'axios'
export default {
  components: {
    WebTop
  },
  data () {
    return {
      user: null,
      
      formValidate: {
        realName: '',
        mobile:'',
        title: '',
        content: ''
      },
      ruleValidate: {
        realName: [
          { required: true, message: '姓名', trigger: 'blur' },
        ],
        mobile: [
          { required: true, message: '手机不能为空', trigger: 'blur' },
        ],
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' },
        ],
        content: [
            { required: true, message: '内容不能为空', trigger: 'blur' },
            { type: 'string', min: 20, message: '内容至少20个字', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.initUser()
  },
  methods: {
    //初始化用户信息
    initUser() {
      let userStr = localStorage.getItem("user")
      if(userStr!=null) {
        this.user = JSON.parse(userStr)
      }
    },
    handleSubmit (name) {
      if(this.user==null) {
        this.$Message.error("请您登录");
        return
      }
      this.$refs[name].validate((valid) => {
          if (valid) {
            let vm = this
            //let id = this.$route.query.id
            axios({
              method: 'post',
              url: global.restUrl + '/api/web/complaint/v1.0/apply/save',
              data: vm.formValidate,
              headers: {
                token: vm.user.token
              }
            }).then(function (response) {
              let success = response.data.success
              if(success) {
                vm.$Message.success('提交成功，请等待管理员审核');
                vm.formValidate.title = ""
                vm.formValidate.content = ""
                vm.formValidate.realName=""
                vm.formValidate.mobile=""
              } else {
                vm.$Message.error(response.data.message)
              }
            });
          } else {
              this.$Message.error('表单校验失败');
          }
      })
    },
  }
}
</script>
